import { useContract } from './useContract'
import { ABI_LAUNCHPAD_POOL } from '../utils/abis'
import { useEffect, useState } from 'react'
import { useWeb3React } from '@web3-react/core'
import { isEqualString } from '../utils'

export default function useUserRaised(poolAddress?: string | null) {
  const contract = useContract(poolAddress, ABI_LAUNCHPAD_POOL)
  const { account } = useWeb3React()
  const [raised, setRaised] = useState<boolean | null>(null)

  useEffect(() => {
    if (contract && account) {
      contract.hasRaised(account).then(setRaised)
      const listener = (sender: string) => {
        if (isEqualString(sender, account)) {
          setRaised(true)
        }
      }
      contract.on('Raise', listener)
      return () => {
        contract.removeListener('Raise', listener)
      }
    }
  }, [account, contract])
  return raised
}
